import { defineMessages } from 'react-intl';

export const messages: {
	cornerStyle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	roundCornerStyleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	squareCornerStyleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	cornerStyle: {
		id: 'company-hub.company-hub-common.links-menu.corner.style',
		defaultMessage: 'Corner style',
		description: 'Text labeling a customization option for corner styling',
	},
	roundCornerStyleLabel: {
		id: 'company-hub.company-hub-common.links-menu.corner.style-round',
		defaultMessage: 'Round',
		description: 'Tooltip and label text label describing the round corner styling option',
	},
	squareCornerStyleLabel: {
		id: 'company-hub.company-hub-common.links-menu.corner.style-square',
		defaultMessage: 'Square',
		description: 'Tooltip and label text describing the square corner styling option',
	},
});
